export default {
  namespaced: true,
  state: {
    robotConfig: {},
    digitalConfig: {},
    outlineConfig: {}
  },
  getters: {
    getRobotSet(state: any) {
      return state.robotConfig
    },
    getDigitalSet(state: any) {
      return state.digitalConfig
    },
    getOutlineConfig(state: any) {
      return state.outlineConfig
    }
  },
  mutations: {
    setRobot(state: any, value: any) {
      state.robotConfig = value
    },
    setDigital(state: any, value: any) {
      state.digitalConfig = value
    },
    setOutlineConfig(state: any, value: any) {
      state.outlineConfig = value
    }
  },
  actions: {}
}
